export enum SystemFeatureAccessEnum {
  READ = 'READ',
  WRITE = 'WRITE',
}

export enum FeatureAccessEnum {
  READ = 'canRead',
  WRITE = 'canWrite',
}
